// extracted by mini-css-extract-plugin
module.exports = {"orders-header":"ordersTableHeader_orders-header__1XRxu"};